<template>
  <div
    v-if="visible"
  >
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div
            class="w-100 h-100"
            role="document"
          >
            <div class="modal-content h-100 border-0 rounded-0 p-4">
              <div class="d-flex justify-content-end">
                <div
                  class="text-center cursor-pointer"
                  @click="visible = false"
                >
                  <h3
                    class="m-0"
                    style="line-height: 0.8"
                  >
                    &#10005;
                  </h3>
                  <small>ESC</small>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center justify-content-between h-100">
                <div class="col-md-7 mt-5">
                  <h5 class="mb-4 pb-2 text-center">
                    CREATE NEW PROJECT
                  </h5>
                  <input
                    v-model="researchName"
                    type="text"
                    class="create-project-input px-5 w-100"

                    placeholder="Name your project"
                  >
                </div>
                <div class="col-md-3 d-flex align-items-end justify-content-center">
                  <!-- TODO deepify-btn -->
                  <button
                    class="col-md-8 create-project-button deepify-bg-success border-0 text-center"
                    @click="$emit('created', researchName)"
                  >
                    CREATE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'Modal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      researchName: '',
    };
  },
  watch: {
    value(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit('input', val);
    },
  },
  created() {
    this.visible = this.value;

    const self = this;

    // eslint-disable-next-line
    document.addEventListener('keyup', function listener(evt) {
      if (evt.keyCode === 27) {
        self.visible = false;
        document.removeEventListener('keyup', listener);
      }
    });
  },
};
</script>

<style>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .create-project-input, .create-project-button {
    border-radius: 29px!important;
    font-size: 13px!important;
    height: 58px;
    line-height: 58px;
  }

  .create-project-input {
    border: solid thin #444444;
  }

  .create-project-input:focus {
    outline: none;
    box-shadow: 0 0 3px #ddd;
  }

  .create-project-button {

  }
</style>
